export const FETCH_LIST_ROLE_REQUEST= "FETCH_LIST_ROLE_REQUEST";
export const FETCH_LIST_ROLE_SUCCESS= "FETCH_LIST_ROLE_SUCCESS";
export const FETCH_LIST_ROLE_FAILURE= "FETCH_LIST_ROLE_FAILURE";

export const FETCH_ALL_LIST_ROLE_REQUEST= "FETCH_ALL_LIST_ROLE_REQUEST";
export const FETCH_ALL_LIST_ROLE_SUCCESS= "FETCH_ALL_LIST_ROLE_SUCCESS";
export const FETCH_ALL_LIST_ROLE_FAILURE= "FETCH_ALL_LIST_ROLE_FAILURE";

// View single ROLE
export const FETCH_ROLE_REQUEST= "FETCH_ROLE_REQUEST";
export const FETCH_ROLE_SUCCESS= "FETCH_ROLE_SUCCESS";
export const FETCH_ROLE_FAILURE= "FETCH_ROLE_FAILURE";

// Add ROLE
export const ADD_ROLE_REQUEST= "ADD_ROLE_REQUEST";
export const ADD_ROLE_SUCCESS= "ADD_ROLE_SUCCESS";
export const ADD_ROLE_FAILURE= "ADD_ROLE_FAILURE";

// Edit ROLE
export const UPDATE_ROLE_REQUEST= "UPDATE_ROLE_REQUEST";
export const UPDATE_ROLE_SUCCESS= "UPDATE_ROLE_SUCCESS";
export const UPDATE_ROLE_FAILURE= "UPDATE_ROLE_FAILURE";

// Delete ROLE
export const DELETE_ROLE_REQUEST= "DELETE_ROLE_REQUEST";
export const DELETE_ROLE_SUCCESS= "DELETE_ROLE_SUCCESS";
export const DELETE_ROLE_FAILURE= "DELETE_ROLE_FAILURE";

// Reset current ROLE
export const RESET_CURRENT_ROLE= "RESET_CURRENT_ROLE";